<template>
    <div class="upload">
        <navTop :isLogin="1" title="相君科技平台用户首页"></navTop>
        <el-dialog title="检验结果" :close-on-click-modal = "false"  :visible.sync="dialogFormVisible"style="width:50%;margin:0 auto">
            <div class="result">
                <div class="content">
                    <div class="left">
                        <div class="message">文件名称：<b>{{name}}</b></div> 
                        <div class="message">是否为本平台电子签章：<b>{{isXJ}}</b></div> 
                         <div class="message">签署方式：<b>{{isPass}}</b></div>
                        <div class="message">证书序列号：<b>{{serialNo}}</b></div> 
                        <div class="message">印章类型：<b>{{type}}</b></div> 
                        <div class="message">证书生效时间：<b>{{signTime}}</b></div> 
                        <div class="message">证书失效时间：<b>{{endTime}}</b></div> 
                        <div class="message">检验时间：<b>{{time}}</b></div> 
                    </div>
                    <!-- <div class="right">
                        <div class="apect"> 
                            已通过 
                            <img src="../../../../static/img/pass.png"/> 
                        </div> 
                        <div class="apect">相君电子印章平台电子印章</div> 
                        <div class="apect">印章类型</div> 
                        <div class="apect">2021/03/12</div> 
                        <div class="apect">2021/03/12</div> 
                        <div class="apect">是</div>
                    </div> -->
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
       
        <div class="all">
            <div class="sign">
<!--                <div class="uplod">-->
<!--                    <div class="load-img">-->
<!--                        <img src="../../../../static/img/addImg.png" @click="$refs.inputer.click()"/>-->
<!--                        <input type="file" id="fileExport" @change="handleFileChange" ref="inputer"-->
<!--                               style="display: none;">-->
<!--                    </div>-->
<!--                    <div class="load-btn" @click="$refs.inputer.click()">-->
<!--                        上传检验-->
<!--                    </div>-->
<!--                </div>-->

              <div class="uplod">
                <div class="load-img" @click="developed">
                  <img id="pdfImg" src="../../../../static/img/addImg.png"/>
                  <input type="file" id="fileExport" accept=".pdf"  ref="inputer"
                         style="display: none;">
                </div>
                <h2 v-show="name !=''">文件名称：{{name}}</h2>
                <div class="load-btn" @click="developed">
                  上传待验真PDF文件
                </div>
                <div class="load-btn" @click="uploadPDF">
                    提交PDF验真
                </div>
              </div>
              <div class="load-btn" @click="returns">
                返回
              </div>

            </div>
        </div>
        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'
    import pdf from 'vue-pdf'

    export default {
        components: {
            navTop,
            navBom,
            pdf
        },
        data() {
            return {
                pdfUrl: "http://47.108.75.235:5389/CM-API//upload/2021-04-13/fd6231dde90c4c789b1d4f557cb89cf4.pdf",
                pageNum: 1,
                pageTotalNum: 1,
                pageRotate: 0,
                // 加载进度
                loadedRatio: 0,
                curPageNum: 0,
                path: '',
                dialogFormVisible:false,
                name:"",
                isXJ:"",
                type:"",
                signTime:"",
                endTime:"",
                time:"",
                isPass:"",
                pdfVal:"",
                serialNo:""
            }
        },
        mounted() {

        },
        methods: {
            handleFileChange(e) {
                let inputDOM = this.$refs.inputer;
                let file = inputDOM.files[0];
                console.log(file);

                /* 限制文件上传类型 */
                let suffixName = file.name.substring(file.name.lastIndexOf('.') + 1);
                if (suffixName !== 'pdf') {
                    this.$message.warning("上传文件只能是 pdf 格式!");
                    return;
                }

                /* 限制文件上传大小 */
                let isLtSize = file.size / 1024 / 1024 < 10;
                if (!isLtSize) {
                    this.$message.warning("上传文件不能超过 10MB!");
                    return;
                }

                let size = Math.floor(file.size / 1024);

                e.target.value = '';
                this.getUplodPath(file);
            },

            async getUplodPath(file) {
                let formdata = new FormData();
                formdata.append('file', file);
                let _this = this;
                let post = () => {
                    return new Promise(resolve => {
                        _this.api.upload(formdata).then(res => {
                            console.log(res);
                            resolve(res.path);
                        })
                    });
                }
                let paht = await post();
                _this.path = paht;
                _this.loudSeal(paht);
            },
            loudSeal(paht) {
                let _this = this;
                let param = new FormData();
                param.append('pdfFilePath', paht);
                _this.api.visitorUpload(param).then(res => {
                    console.log(res)
                })
            },
            prePage() {
                var p = this.pageNum
                p = p > 1 ? p - 1 : this.pageTotalNum
                this.pageNum = p
            },
            nextPage() {
                var p = this.pageNum
                p = p < this.pageTotalNum ? p + 1 : 1
                this.pageNum = p
            },
            clock() {
                this.pageRotate += 90
            },
            counterClock() {
                this.pageRotate -= 90
            },
            password(updatePassword, reason) {
                updatePassword(prompt('password is "123456"'))
                console.log('...reason...')
                console.log(reason)
                console.log('...reason...')
            },
            pageLoaded(e) {
                this.curPageNum = e
            },
            pdfError(error) {
                console.error(error)
            },
            pdfPrintAll() {
                this.$refs.pdf.print()
            },
            pdfPrint() {
                this.$refs.pdf.print(100, [1, 2])
            },

            developed(){
              document.getElementById("fileExport").click();
              let _this = this;
              document.getElementById('fileExport').addEventListener('change', function(event) {
                document.getElementById('pdfImg').src = "../../../../static/img/pdf.png"
                const file = event.target.files[0]; 
                _this.pdfVal = file
                _this.name = file.name
            });
            },

            uploadPDF(){
                let _this = this
                var file = _this.pdfVal
                if (file) {
                    let params = new FormData();
                    params.append('file', file)
                    _this.api.visitorUpload(params).then(res => {
                        if( res.code!=0 ){
                            _this.$message.error("非本平台签署文件");
                        }else{
                            _this.dialogFormVisible = true
                            var data = res.data
                            _this.isXJ = data.ou == true ? "是":"否"
                            _this.type = data.type == "1" ? "个人":"企业"
                            _this.signTime = data.start.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1-$2-$3 $4:$5:$6');
                            _this.endTime = data.end.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1-$2-$3 $4:$5:$6');
                            _this.time = data.time
                            _this.isPass = data.isPass == true ? "线上签署":"离线软件签署"
                            _this.serialNo= data.serialNo
                        }
                    })
                }else{
                    this.$message.error('请先上传合同文件');
                }
                
            },
            returns(){
              this.$router.replace('/loginMenu');
            }

        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .upload {
        width: @a;
        height: auto;

        .all {
            width: @a;
            height: auto;
            display: @flex;
            justify-content: center;
            padding: 2% 0;

            .sign {
                width: 1500px;
                height: auto;
                padding: 10px;
                //display: @flex;
                //justify-content: space-between;

                .uplod {
                    width: 180px;
                    height: auto;
                    //margin-right: 30px;
                    margin: auto;

                    .load-img {
                        width: 180px;
                        height: 180px;

                        img {
                            width: 180px;
                            height: 180px;
                        }
                    }

                    .load-btn {
                        width: 180px;
                        height: 50px;
                        cursor: pointer;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal,
                        normal;
                        color: #fff;
                        @row();
                        margin-top: 30px;
                    }
                }

                .pic {
                    width: 600px;
                    height: auto;
                    border: solid 1px #aaaaaa;
                    padding: 2px;

                    .pdf-tab {
                        width: 100%;
                        height: 100px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .btn-def {
                            width: 100px;
                            height: 40px;
                            line-height: 40px;
                            text-align: center;
                            background-image: linear-gradient(270deg,
                            #1e6eee 0%,
                            #109ee7 50%,
                            #01cee0 100%),
                            linear-gradient(#000000,
                            #000000);
                            background-blend-mode: normal,
                            normal;
                            color: #fff;
                            font-size: 24px;
                            cursor: pointer;
                        }

                        .btn-pre {
                            width: 100px;
                            height: 40px;
                            line-height: 40px;
                            text-align: center;
                            font-size: 24px;

                            border: solid 0.013333rem #aaaaaa;
                            margin: 0 20px;
                        }
                    }
                }

                .result {
                    width: 600px;
                    height: 520px;
                    margin-left: 50px;

                    .title {
                        width: auto;
                        height: 50px;
                        line-height: 50px;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal,
                        normal;
                        color: #fff;
                        font-size: 24px;
                        padding-left: 22px;
                    }

                    .content {
                        width: auto;
                        height: 45px;
                        background-image: url(../../../../static/img/result.png);
                        background-size: 100% 100%;
                        background-blend-mode: normal,
                        normal;
                        opacity: 0.8;
                        display: @flex;
                        align-items: center;
                        justify-content: center;

                        .left {
                            
                            display: @flex;
                            flex-direction: column;
                            justify-content: space-around;
                            align-items: center;
                        }

                        .right {
                            width: 260px;
                            height: 400px;
                            margin-left: 36px;
                            display: @flex;
                            flex-direction: column;
                            justify-content: space-around;
                            align-items: center;
                        }

                        .message {
                            font-size: 24px;
                            letter-spacing: 1px;
                            color: #ffffff;
                            width: @a;
                            height: auto;
                            text-align: center;
                        }

                        .apect {
                            font-size: 18px;
                            letter-spacing: 1px;
                            color: #ffffff;
                            width: @a;
                            height: auto;
                            display: @flex;
                            justify-content: flex-start;

                            img {
                                width: 25px;
                                height: 25px;
                                margin-left: 10px;
                            }
                        }
                    }
                }
            }

        }

    }
    .load-btn {
      margin: 20px auto 0;
      width: 180px;
      height: 50px;
      cursor: pointer;
      background-image: linear-gradient(270deg,
      #1e6eee 0%,
      #109ee7 50%,
      #01cee0 100%),
      linear-gradient(#000000,
      #000000);
      background-blend-mode: normal,
      normal;
      color: #fff;
      @row();
      margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/signature/yk_jy.vue